import React, { useEffect, useState } from 'react';
import { Dimmer, Loader } from 'semantic-ui-react';

import { AxiomLogo } from '../AxiomLogo/AxiomLogo';
import { Gutter } from '../../layout/Gutter/Gutter';
import { SmallHeader } from '../../content/SmallHeader/SmallHeader';
import { CondensedLarge } from '../../content/CondensedLarge/CondensedLarge';
import { Grid } from '../../layout/Grid/Grid';
import { GridColumn } from '../../layout/Grid/GridColumn';

export type LoaderExtendedProps = {
  headers?: string[];
  name?: string;
  description?: string;
};

export type LoaderWithVerbiageProps = {
  className?: string;
  name?: string;
  loaderExtended?: LoaderExtendedProps;
};

export const LoaderWithVerbiage = ({
  className = '',
  name,
  loaderExtended,
}: LoaderWithVerbiageProps) => {
  const combinedClassName =
    `axiom-loader with-verbiage fullscreen expand-fullscreen ${className}`.trim();
  const { headers, description } = { ...loaderExtended };

  const [header, setHeader] = useState(headers ? headers[0] : undefined);
  useEffect(() => {
    if (!headers) return;
    let counter = 1;
    const interval = setInterval(() => {
      setHeader(headers[counter]);
      if (counter === headers.length - 1) {
        counter = 0;
      } else {
        counter++;
      }
    }, 4000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div className={combinedClassName} data-test={name}>
      <div
        className="axiom-loader-extended"
        data-test={name ?? 'loaderExtendedDiv'}
      >
        <Dimmer active className="extendedLoader">
          <Gutter bottom="50px" className="gutterWrapper">
            <AxiomLogo />
          </Gutter>
          <Gutter bottom="50px">
            <div className="loader-container">
              <Loader indeterminate size="massive" />
            </div>
          </Gutter>
          {headers ? (
            <Gutter bottom="24px">
              <SmallHeader className="extendedLoaderHeader">
                {header}
              </SmallHeader>
            </Gutter>
          ) : null}
          {description ? (
            <Grid
              columns={12}
              textAlign="center"
              className="extendedLoaderDescription gutterWrapper"
            >
              <GridColumn
                largeScreenWidth={5}
                mobileWidth={12}
                className="gutterWrapper"
              >
                <CondensedLarge>{description}</CondensedLarge>
              </GridColumn>
            </Grid>
          ) : null}
        </Dimmer>
      </div>
    </div>
  );
};
